import React from 'react';
import { Card } from '@tribeplatform/react-ui-kit/Card';
export const CardHeaderBlock = ({ title, description, size, withBorder, }) => {
    return (React.createElement(Card.Header, { title: title, description: description, size: size, withBorder: withBorder }));
};
//# sourceMappingURL=Block.js.map